import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import Response_Processing from "../../../../../src/layout/Others/Response_Processing";
import backarrow from "../../../../components/Images/backarrow.svg";
import AdminBackNavigation from "../../../../components/CommonComponents/AdminBackNavigation";
import AdminSwitch from "../../../../components/CommonComponents/AdminSwitch";
import { toast } from "react-toastify";


function Payouts_Setting(props) {
  const [message, setMessage] = useState("");

  const [setting, setSetting] = useState({
    // Advertisement_Setting
    ads_on_videos: "",
    cpc_advertiser: "",
    featured_pre_ad: "",
    featured_mid_ad: "",
    featured_post_ad: "",
    cpc_admin: "",
    cpv_advertiser: "",
    cpv_admin: "",
    default_ads_url: "",
    ads_play_unlimited_period: "",
    ads_on_livestream: "",
    ads_on_audios: "",
    ads_on_episodes: "",
    // Advertisement_Setting
    //coupon code
    new_subscriber_coupon: "",
    discount_percentage: "",
    coupon_code: "",
    //coupon code
    //email setting
    google_oauth_key: "",
    coupon_status: "",
    google_tracking_id: "",
    system_email: "",
    system_phone_number: "",
    system_address: "",
    //email setting
    //login setting
    notification_icon: "",
    notification_key: "",
    login_text: "",
    login_content: "",
    signature: "",
    //login setting
    //geo fencing
    id: "",
    geofencing: "",
    geofencing_status: "",
    //geo fencing

    // payout setting
    payment_vai: "manual",
    amount_per_view: "",
    monetization_view_limit: "",
    video_view_limit: "",
    paymentgateway: 0,
    //payout setting

    //ppv setting
    ppv_status: "",
    ppv_rent: "",
    ppv_price: "",
    ppv_hours: "",
    ios_product_id: "",
    ios_plan_price: "",
    expiry_time_started: "",
    expiry_day_notstarted: "",
    expiry_hours_notstarted: "",
    expiry_min_notstarted: "",
    PPV_Individual_Contents: "",
    enable_ppv_rent_live: "",
    enable_ppv_rent_series: "",
    enable_ppv_rent_audio: "",
    google_analytics_link: "",
    //ppv setting
    // capcha setting
    captcha_site_key: "",
    captcha_secret_key: "",
    captcha: "",
    //capcha setting
    //registration settings
    free_registration: "",
    activation_email: "",
    premium_upgrade: "",
    access_free: "",
    enable_landing_page: "",
    //registration settings
    //search settings
    search_title_status: "",
    search_category_status: "",
    search_tags_status: "",
    search_description_status: "",
    search_details_status: "",
    //search settings
    //series settings
    series_season: "",
    series_networks_status: "",
    //series settings
    //site settings
    website_name: "",
    website_description: "",
    logo_height: "",
    logo_width: "",
    login_content: "",
    favicon: "",
    logo: "",
    //site settings
    //social network settings
    facebook_page_id: "",
    google_page_id: "",
    twitter_page_id: "",
    instagram_page_id: "",
    linkedin_page_id: "",
    whatsapp_page_id: "",
    skype_page_id: "",
    youtube_page_id: "",
    email_page_id: "",
    tiktok_page_id: "",
    //social network settings
    //video settings
    videos_per_page: "",
    posts_per_page: "",
    show_description: "",
    show_Links_and_details: "",
    show_genre: "",
    show_languages: "",
    show_subtitle: "",
    show_artist: "",
    show_recommended_videos: "",
    show_views: "",
    videos_expiry_status: "",
    epg_status: "",
    //video settings
    earn_amount: "",
    video_clip_enable: "",
    enable_ppv_rent: "",
    amount_per_view: "",
    monetization_view_limit: "",

  });

  const navigate = useNavigate();
  const access_token = localStorage.getItem("access_token");

  const headers = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + access_token,
    "Content-Type": "application/json",
    Accept: "application/json",
    "Access-Control-Allow-Origin": "*",
  };

  useEffect(async () => {
    await axios
      .get(`${process.env.REACT_APP_Baseurl}/admin/Partner-monetization-setting/index `, {
        headers: headers,
      })
      .then((response) => {
        var setting = response?.data?.PartnerMonetizationSettings;
        console.log("SETTINGS:", setting)

        setSetting(setting);
      })
      .catch((error) => console.log(error));
  }, []);


  const handleInputenable = (key) => {
    setSetting((prev) => ({
      ...prev,
      [key]: prev[key] === "paymentgateway" ? "manual" : "paymentgateway",
    }));
  };


  const [errors, setErrors] = useState({
    monetization_view_limit: false,
  });
  const handleInput = (e) => {
    const { name, value, type } = e.target;

    // Clear error when user starts typing
    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: false }));
    }

    let newValue = value;

    if (type === "number") {
      const parsedValue = parseInt(value, 10);
      // Return empty string if NaN, otherwise ensure it's not negative
      newValue = isNaN(parsedValue) ? "" : Math.max(0, parsedValue);
    }

    setSetting((prev) => ({
      ...prev,
      [name]: newValue,
    }));
  };

  const [processing, setProcessing] = useState(false);
  const [showOverlay, setShowOverlay] = useState(false);
  console.log("setting?.payment_vai", setting?.payment_vai);

  const handleUpdate = async (e) => {
    e.preventDefault();

    // Validate fields
    const newErrors = {
      monetization_view_limit: setting?.monetization_view_limit === null || setting?.monetization_view_limit === undefined || setting?.monetization_view_limit === '',
    };


    setErrors(newErrors);

    if (Object.values(newErrors).some(error => error)) {
      return;
    }

    const enable_ppv_rent = Number.isNaN(parseInt(setting?.enable_ppv_rent, 10)) ? 0 : parseInt(setting?.enable_ppv_rent, 10);

    // advertisement setting
    const ads_on_videos = Number.isNaN(parseInt(setting?.ads_on_videos, 10)) ? 0 : parseInt(setting?.ads_on_videos, 10);
    const ads_play_unlimited_period = Number.isNaN(parseInt(setting?.ads_play_unlimited_period, 10)) ? 0 : parseInt(setting?.ads_play_unlimited_period, 10);
    const ads_on_livestream = Number.isNaN(parseInt(setting?.ads_on_livestream, 10)) ? 0 : parseInt(setting?.ads_on_livestream, 10);
    const ads_on_audios = Number.isNaN(parseInt(setting?.ads_on_audios, 10)) ? 0 : parseInt(setting?.ads_on_audios, 10);
    const ads_on_episodes = Number.isNaN(parseInt(setting?.ads_on_episodes, 10)) ? 0 : parseInt(setting?.ads_on_episodes, 10);

    //coupon setting      
    const coupon_code = Number.isNaN(parseInt(setting?.coupon_code, 10)) ? 0 : parseInt(setting?.coupon_code, 10);


    //payout settings   
    const payment_vai = Number.isNaN(parseInt(setting?.payment_vai, 10)) ? 0 : parseInt(setting?.payment_vai, 10);


    //registration settings
    const free_registration = Number.isNaN(parseInt(setting?.free_registration, 10)) ? 0 : parseInt(setting?.free_registration, 10);


    //search settings
    const search_title_status = Number.isNaN(parseInt(setting?.search_title_status, 10)) ? 0 : parseInt(setting?.search_title_status, 10);
    const search_category_status = Number.isNaN(parseInt(setting?.search_category_status, 10)) ? 0 : parseInt(setting?.search_category_status, 10);
    const search_tags_status = Number.isNaN(parseInt(setting?.search_tags_status, 10)) ? 0 : parseInt(setting?.search_tags_status, 10);
    const search_description_status = Number.isNaN(parseInt(setting?.search_description_status, 10)) ? 0 : parseInt(setting?.search_description_status, 10);
    const search_details_status = Number.isNaN(parseInt(setting?.search_details_status, 10)) ? 0 : parseInt(setting?.search_details_status, 10);


    //serires settings
    const series_networks_status = Number.isNaN(parseInt(setting?.series_networks_status, 10)) ? 0 : parseInt(setting?.series_networks_status, 10);

    // video settings 
    const videos_expiry_status = Number.isNaN(parseInt(setting?.videos_expiry_status, 10)) ? 0 : parseInt(setting?.videos_expiry_status, 10);
    const videos_per_page = Number.isNaN(parseInt(setting?.videos_per_page, 10)) ? 0 : parseInt(setting?.videos_per_page, 10);
    const epg_status = Number.isNaN(parseInt(setting?.epg_status, 10)) ? 0 : parseInt(setting?.epg_status, 10);
    const show_genre = Number.isNaN(parseInt(setting?.show_genre, 10)) ? 0 : parseInt(setting?.show_genre, 10);
    const show_languages = Number.isNaN(parseInt(setting?.show_languages, 10)) ? 0 : parseInt(setting?.show_languages, 10);
    const show_subtitle = Number.isNaN(parseInt(setting?.show_subtitle, 10)) ? 0 : parseInt(setting?.show_subtitle, 10);
    const show_artist = Number.isNaN(parseInt(setting?.show_artist, 10)) ? 0 : parseInt(setting?.show_artist, 10);
    const show_recommended_videos = Number.isNaN(parseInt(setting?.show_recommended_videos, 10)) ? 0 : parseInt(setting?.show_recommended_videos, 10);
    const show_views = Number.isNaN(parseInt(setting?.show_views, 10)) ? 0 : parseInt(setting?.show_views, 10);
    const show_Links_and_details = Number.isNaN(parseInt(setting?.show_Links_and_details, 10)) ? 0 : parseInt(setting?.show_Links_and_details, 10);
    const show_description = Number.isNaN(parseInt(setting?.show_description, 10)) ? 0 : parseInt(setting?.show_description, 10);

    const editInputvalue = {

      // advertisement setting
      ads_on_videos: ads_on_videos,
      default_ads_url: setting?.default_ads_url,
      featured_pre_ad: setting?.featured_pre_ad,
      featured_mid_ad: setting?.featured_mid_ad,
      featured_post_ad: setting?.featured_post_ad,
      cpv_admin: setting?.cpv_admin,
      cpv_advertiser: setting?.cpv_advertiser,
      cpc_admin: setting?.cpc_admin,
      cpc_advertiser: setting?.cpc_advertiser,
      ads_play_unlimited_period: ads_play_unlimited_period,
      ads_on_livestream: ads_on_livestream,
      ads_on_audios: ads_on_audios,
      ads_on_episodes: ads_on_episodes,

      //coupon setting      
      discount_percentage: setting?.discount_percentage,
      coupon_code: coupon_code,
      new_subscriber_coupon: setting?.new_subscriber_coupon,

      //email settings
      coupon_status: setting?.coupon_status,
      google_tracking_id: setting?.google_tracking_id,
      google_oauth_key: setting?.google_oauth_key,
      system_email: setting?.system_email,
      system_phone_number: setting?.system_phone_number,

      //login settings      
      login_text: setting?.login_text,
      signature: setting?.signature,
      login_content: setting?.login_content,
      notification_key: setting?.notification_key,

      //payout setting
      payment_vai: setting?.payment_vai,
      // amount_per_view: setting?.amount_per_view,
      // monetization_view_limit: setting?.monetization_view_limit,
      // video_view_limit: setting?.video_view_limit,
      amount_per_view: parseInt(setting?.amount_per_view) || 0,
      monetization_view_limit: parseInt(setting?.monetization_view_limit) || 0,
      video_view_limit: parseInt(setting?.video_view_limit) || 0,
      paymentgateway: 0,

      //ppv settings
      ppv_status: setting?.ppv_status,
      PPV_Individual_Contents: setting?.PPV_Individual_Contents,
      ppv_price: setting?.ppv_price,
      ppv_hours: setting?.ppv_hours,
      ios_plan_price: setting?.ios_plan_price,
      ios_product_id: setting?.ios_product_id,
      expiry_time_started: setting?.expiry_time_started,
      expiry_day_notstarted: setting?.expiry_day_notstarted,
      expiry_hours_notstarted: setting?.expiry_hours_notstarted,
      expiry_min_notstarted: setting?.expiry_min_notstarted,
      enable_ppv_rent_live: setting?.enable_ppv_rent_live,
      enable_ppv_rent_series: setting?.enable_ppv_rent_series,
      enable_ppv_rent_audio: setting?.enable_ppv_rent_audio,
      google_analytics_link: setting?.google_analytics_link,

      //registration settings
      enable_landing_page: setting?.enable_landing_page,
      free_registration: free_registration,
      activation_email: setting?.activation_email,
      premium_upgrade: setting?.premium_upgrade,
      access_free: setting?.access_free,

      //search settings
      search_title_status: search_title_status,
      search_category_status: search_category_status,
      search_tags_status: search_tags_status,
      search_description_status: search_description_status,
      search_details_status: search_details_status,

      //serires settings
      series_season: setting?.series_season,
      series_networks_status: series_networks_status,

      //site settings
      website_name: setting?.website_name,
      website_description: setting?.website_description,
      // logo: setting?.logo,
      logo_height: setting?.logo_height,
      logo_width: setting?.logo_width,
      // favicon: setting?.favicon,

      //social network settings
      facebook_page_id: setting?.facebook_page_id,
      google_page_id: setting?.google_page_id,
      twitter_page_id: setting?.twitter_page_id,
      instagram_page_id: setting?.instagram_page_id,
      linkedin_page_id: setting?.linkedin_page_id,
      whatsapp_page_id: setting?.whatsapp_page_id,
      skype_page_id: setting?.skype_page_id,
      youtube_page_id: setting?.youtube_page_id,
      tiktok_page_id: setting?.tiktok_page_id,
      email_page_id: setting?.email_page_id,

      //default_time_zone
      default_time_zone: setting?.default_time_zone,

      // video settings 
      videos_per_page: videos_per_page,
      posts_per_page: setting?.posts_per_page,
      show_description: show_description,
      show_Links_and_details: show_Links_and_details,
      show_genre: show_genre,
      show_languages: show_languages,
      show_subtitle: show_subtitle,
      show_artist: show_artist,
      show_recommended_videos: show_recommended_videos,
      show_views: show_views,
      videos_expiry_status: videos_expiry_status,
      epg_status: epg_status,

      epg_status: enable_ppv_rent,

      earn_amount: setting?.earn_amount ? parseInt(setting?.earn_amount, 10) : 0,
      video_clip_enable: setting?.video_clip_enable ? parseInt(setting?.video_clip_enable, 10) : 0,

      //Monetization Settings
      // monetization_view_limit: setting?.monetization_view_limit,
      // amount_per_view: setting?.amount_per_view,

    };


    setProcessing(true);
    setShowOverlay(true);

    let result = await fetch(
      `${process.env.REACT_APP_Baseurl}/admin/Partner-monetization-setting/update`,
      {
        method: "POST",
        headers: headers,
        body: JSON.stringify(editInputvalue),
      }
    );

    const response = await result?.json();

    console.log(`res?.data?.status ${JSON.stringify(response, null, 2)}, status: ${response?.status}`);
    

    if (response?.status === true) {
      var resultapi = response?.data;
      setSetting(resultapi);
      setShowOverlay(false);
      toast.success(response?.message)
    } else {
      toast.error(response?.message)
    }
  };


  return (
    <>
      <AdminBackNavigation path="/settings" text="Back" />
      <div className=" m-0 p-0">
        <div className="">
          <section className="section  container-fluid">
            <div className="">
              <div className="col-lg-12 row py-3">
                <div className="col-6 col-sm-6 col-lg-6">
                  <h4 className="admin-title mb-0 theme-text-color">Payouts Settings</h4>
                </div>
                <div className="col-6 col-sm-6 col-lg-6">
                  <div className="text-end">
                    <button onClick={handleUpdate} className="button-bg-color theme-button-text-color admin-button-text rounded-3 py-2 px-3">
                      Save Payouts
                    </button>
                  </div>
                </div>
              </div>

              <div>
                {showOverlay && <Response_Processing></Response_Processing>}
              </div>

              <div className="col-lg-12 row">
                <div className="col-lg-6 col-md-6 col-sm col-6">
                  <div className="iq-card">

                    <h5 className="theme-text-color theme-border-secondary-color pb-3 mb-3 mt-0">Payouts Status</h5>
                    <div className=" text-start mt-2">
                      <div className="" id="cpp_payouts">
                        <div className="row" data-collapsed="0">
                          <div className="panel-body">
                            <div className="row">
                              <div>
                                <p className="mt-1"> </p>
                              </div>
                              <div className="row align-items-center">
                                <div className="col-lg-4 text-end">
                                  <p className="p2">Manual</p>
                                </div>
                                <div className="col-lg-4">
                                  <div className="d-flex align-items-center justify-content-center">
                                    <div className="mt-1">
                                      <AdminSwitch
                                        name="payment_vai"
                                        checked={setting.payment_vai === "paymentgateway"}
                                        onChange={() => handleInputenable("payment_vai")}
                                        id="payment-vai-toggle"
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div className="col-lg-4 text-start">
                                  <p className="p2">Payment Gateway</p>
                                </div>
                              </div>

                            </div>
                          </div>
                        </div>
                      </div>
                      {/* <div className="text-end p-3">
                  <input
                    type="submit"
                    id="appupdate"
                    onClick={handleUpdate}
                    value="Update Setting"
                    className="btn btn-primary ml-3 "
                  />
                </div> */}
                    </div>
                  </div>

                </div>
                <div className="col-lg-6 col-md-6 col-sm col-6">
                  <div className="iq-card">
                    <div>
                      <h5 className="theme-text-color theme-border-secondary-color pb-3 mb-3 mt-0">Partner Monetization Settings</h5>
                      {/* <div className=" text-start">
                        <p className="mandatorySimple theme-text-color mb-3 mt-0 admin-input-title d-block position-relative">
                          Monetization View Limit
                        </p>
                        <div>
                          <div className="mt-2">
                            <input
                              type="number"
                              name="monetization_view_limit"
                              value={setting?.monetization_view_limit}
                              className={`rs-input form-control-lg custom-input custom-input-border w-100 custom-placeholder bg-transparent theme-text-color mb-3 ${errors.monetization_view_limit ? 'is-invalid' : ''}`}
                              onChange={handleInput}
                              placeholder=""
                              min="0" // Set minimum to 1 to prevent zero
                            />
                            {errors.monetization_view_limit && (
                              <div className="errorred">This field  cannot be empty.

                              </div>
                            )}
                          </div>
                        </div>
                      </div> */}
                      <div className="text-start">
                        <p className="mandatorySimple theme-text-color mb-3 mt-0 admin-input-title d-block position-relative">
                          Monetization View Limit
                        </p>
                        <div>
                          <div className="mt-2">
                            <input
                              type="number"
                              name="monetization_view_limit"
                              value={setting?.monetization_view_limit}
                              className={`rs-input form-control-lg custom-input custom-input-border w-100 custom-placeholder bg-transparent theme-text-color mb-3 ${errors.monetization_view_limit ? 'is-invalid' : ''}`}
                              onChange={handleInput}
                              placeholder=""
                              min="0"
                              onKeyDown={(e) => {
                                // Prevent minus key
                                if (e.key === '-' || e.key === 'e' || e.key === 'E' || e.key ==='+') {
                                  e.preventDefault();
                                }
                              }}
                            />
                            {errors.monetization_view_limit && (
                              <div className="errorred">This field  cannot be empty.</div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className=" text-start mt-2">
                      <p className="theme-text-color mb-3 mt-0 admin-input-title d-block position-relative">Amount per view</p>
                      <div>
                        <div className="mt-2">
                          <input
                            type="number"
                            // id="featured_pre_ad"
                            name="amount_per_view"
                            // value={setting?.amount_per_view}
                            value={setting?.amount_per_view}

                            className="rs-input form-control-lg custom-input custom-input-border w-100 custom-placeholder bg-transparent theme-text-color mb-3"
                            onChange={handleInput}
                            placeholder=""
                          />
                        </div>
                      </div>

                    </div>

                    <div className=" text-start mt-2">
                      <p className="theme-text-color mb-3 mt-0 admin-input-title d-block position-relative">Video View Limit</p>
                      <div>
                        <div className="mt-2">
                          <input
                            type="number"
                            // id="featured_pre_ad"
                            name="video_view_limit"
                            // value={setting?.video_view_limit}
                            value={setting?.video_view_limit}
                            className="rs-input form-control-lg custom-input custom-input-border w-100 custom-placeholder bg-transparent theme-text-color mb-3"
                            onChange={handleInput}
                            placeholder=""
                          />
                        </div>
                      </div>

                    </div>

                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  );
}

export default Payouts_Setting;
